import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface BorrRommsProps {
  onBack: () => void;
}

export default function BorrRomms({ onBack }: BorrRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Borrowings" />;
}


